/**
 * Kept out of `DebugHelper.js` on purpose. This file's only job is to import
 * `BoardProcessorDebug.js` and drain WASM log entries onto the panel. Putting
 * that import in `DebugHelper` would load the WASM glue for every module that
 * only needs debug modes, filters, or `logIfSettingsPass` (including workers).
 */
import { exportLogEntries } from '../league/wasm/BoardProcessorDebug.js';
import { publishDebugLogEntries } from './DebugHelper.js';

/**
 * Exports buffered WASM log entries and publishes them on EventBus.
 * Call from the main thread after a WASM operation finishes.
 * @returns {Array<object>} The exported entries (empty when mode is not a DS panel mode)
 */
export const exportAndPublishWasmLogEntries = () => {
    const entries = exportLogEntries();
    publishDebugLogEntries(entries);
    return entries;
};
